export default function () {
  return {
    userInfo: {},
    nodes: [],
    nodeId: null,
    nodeNavigationContexts: {},
    nodeNavigationStatus: {},
    nodeNavigationSequence: 0,
    navigationSessionGeneration: 0,
    pendingNodeId: null,
    defaultNode: null,
    organization: [],
    userRoles: [],
    isLoaded: false,
    isCommonLoaded: false,
    isRouteLoaded: false,
    routeInitScope: null,
    apiClient: null,
    isDisable: false, // パンクズメニュー disableフラグ
  }
}
